export default "__VITE_ASSET__CQwByKaa__ 640w, __VITE_ASSET__DEBLScbd__ 960w, __VITE_ASSET__2DNuu1fk__ 1280w, __VITE_ASSET__88O1fWg6__ 1920w";